import React from 'react';
import { useNavigate } from 'react-router-dom';

import useResponsive from '../hooks/useResponsive';
import { COMPANY_MODE } from '../types/types';
import { persistData } from '../utils/localStorage';
import { LOGO_PATH, LOGO_SQUARE_PATH } from '../variables/GlobalVariables';

export default function Logo() {
  const { isDesktop } = useResponsive();
  const navigate = useNavigate();

  function onClick() {
    persistData('mode', COMPANY_MODE);
    navigate('/home');
  }

  return (
    <img
      onClick={onClick}
      style={{ cursor: 'pointer' }}
      alt="logo"
      src={isDesktop ? LOGO_PATH : LOGO_SQUARE_PATH}
      width={isDesktop ? 200 : 32}
      height={isDesktop ? 40 : 32}
    />
  );
}
